import type { PhotoGeoMap } from '../../lib/photoLocation';
export interface WaterProgram {
  program: string;
  programName: string;
  /** New shape: multiple start times per program. Legacy records may instead
   *  carry a single `startTime` — read via readStartTimes() to tolerate both. */
  startTimes?: string[];
  startTime?: string;
  duration: number;
  days: string[];
}

export interface WaterSchedule {
  programs: WaterProgram[];
}

export interface Controller {
  id: string;
  controller_number: number;
  description: string;
  location: string;
  photo_url: string | null;
  water_start_times: WaterSchedule | null;
  zone_inspections: ZoneInspection[];
}

export interface ZoneIssue {
  id: string;
  work_code: string;
  notes: string;
  photo_urls: string[];
  photo_geo?: PhotoGeoMap | null;
}

export interface ZoneInspection {
  id: string;
  zone_number: number;
  type: string;
  work_codes: string;
  notes: string | null;
  photo_urls: string[];
  photo_geo?: PhotoGeoMap | null;
  issues?: ZoneIssue[];
}

export interface DoubleCheckInspection {
  id: string;
  description: string;
  size: number;
  failure_codes: string[];
  notes: string;
  photo_urls: string[];
  photo_geo?: PhotoGeoMap | null;
}

export interface ControllerInspectionData {
  controller_id: string;
  failure_codes: string[];
  notes: string;
  photo_urls: string[];
  photo_geo?: PhotoGeoMap | null;
}

export interface BrandSettingsData {
  company_name: string;
  logo_url: string | null;
}

export interface ReportStyleSettings {
  header_color: string;
  header_text_color: string;
  body_background_color: string;
  body_text_color: string;
  table_header_color: string;
  table_header_label_color: string;
  section_heading_color: string;
  controller_header_color: string;
  info_label_color: string;
  summary_bg_color: string;
  summary_text_color: string;
  summary_highlight_color: string;
  border_color: string;
  ok_status_color: string;
  issue_status_color: string;
  issue_row_bg_color: string;
}

export const DEFAULT_REPORT_STYLE: ReportStyleSettings = {
  header_color: '#5B1A2A',
  header_text_color: '#FFFFFF',
  body_background_color: '#FFFFFF',
  body_text_color: '#2D2D2D',
  table_header_color: '#F0EDE6',
  table_header_label_color: '#3E3E3E',
  section_heading_color: '#5B1A2A',
  controller_header_color: '#F5F3EE',
  info_label_color: '#6B6B5E',
  summary_bg_color: '#F5F3EE',
  summary_text_color: '#2D2D2D',
  summary_highlight_color: '#A0522D',
  border_color: '#D5CEBD',
  ok_status_color: '#4A6B2A',
  issue_status_color: '#A0522D',
  issue_row_bg_color: '#FDF6EF',
};

export interface PhotoIndexItem {
  id: string;
  url: string;
  label: string;
  category: 'zone' | 'controller' | 'doublecheck';
  refId: string;
}

export interface AccountManagerData {
  name: string | null;
  email: string | null;
  phone: string | null;
}
